import { FormattedMessage } from 'react-intl';

import Pin from 'public/assets/icons/pincut.svg';

import * as S from './style';

import { ContentHeaderProps } from './types';

const ContentHeader: React.FC<ContentHeaderProps> = ({
  topic,
  title,
  programName,
  onClickBackButton,
}) => {
  return (
    <S.ContentHeader data-testid="content-header">
      <S.PinIconsContainer>
        <S.PinIcon>
          <Pin />
        </S.PinIcon>
        <S.PinIcon>
          <Pin />
        </S.PinIcon>
      </S.PinIconsContainer>
      <S.BackButton onClick={onClickBackButton} data-testid="content-button">
        <S.BackIcon> {'<'} </S.BackIcon>
        {programName ? (
          <>
            <FormattedMessage id="TOPIC.PAGE.BACKBUTTON" /> {programName}
          </>
        ) : (
          <FormattedMessage id="TOPIC.PAGE.BACKBUTTON.EMPTY" />
        )}
      </S.BackButton>
      <S.HeaderBody>
        <S.TopicName data-testid="content-topic">
          {topic || <FormattedMessage id="PAGE.NAME.NOTFOUND" />}
        </S.TopicName>
        <S.Title data-testid="content-title">
          {title || <FormattedMessage id="PAGE.NAME.NOTFOUND" />}
        </S.Title>
      </S.HeaderBody>
    </S.ContentHeader>
  );
};

export default ContentHeader;
